import React from "react";
import { StyleSheet, View } from "react-native";
import { ThemeProvider } from "react-native-elements";

const mainColor = "#44d9e6";
const backgroundColor = "#fff";
const secondaryBackgroundColor = "#f1f1f1";
const errorColor = "#cc0000";
const descriptionColor = "#999999";

export const attributes = {
  mainColor,
  backgroundColor,
  secondaryBackgroundColor,
  errorColor,
  descriptionColor,
  Button: {
    raised: true,
    titleStyle: {
      color: backgroundColor,
    },
    containerStyle: {
      borderRadius: 20,
      backgroundColor: backgroundColor,
    },
    buttonStyle: {
      borderRadius: 20,
      height: 50,
      width: 175,
    },
  },
  colors: {
    primary: mainColor,
    underlineColor: "red",
  },
};

export class Theme extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ThemeProvider theme={attributes}>
        <View style={styles.container}>{this.props.children}</View>
      </ThemeProvider>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 30,
    minHeight: 500,
  },
});
